// Lovable Product Detail Page — gallery, pickers, accordions, sticky bar, notify modal.
(function () {
  const root = document.querySelector('[data-lv-pdp]');
  if (!root) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------- Desktop gallery ---------------- */
  (function desktopGallery() {
    const gallery = root.querySelector('[data-lv-gallery-desktop]');
    if (!gallery) return;

    const frame = gallery.querySelector('[data-lv-frame]');
    const images = Array.from(gallery.querySelectorAll('[data-lv-frame-item]'));
    const thumbs = Array.from(gallery.querySelectorAll('[data-lv-thumb]'));
    let index = 0;

    function show(i) {
      index = (i + images.length) % images.length;
      images.forEach((item, n) => {
        item.hidden = n !== index;
        const video = item.querySelector('video');
        if (video) {
          if (n === index) {
            // Videos are muted + looping, so autoplay is allowed by browsers.
            const attempt = video.play();
            if (attempt && attempt.catch) attempt.catch(() => {});
          } else {
            video.pause();
          }
        }
      });
      thumbs.forEach((t, n) => t.classList.toggle('is-active', n === index));
      if (frame) frame.dataset.lvActiveType = images[index] ? images[index].dataset.lvMediaType : 'image';
    }

    gallery.querySelectorAll('[data-lv-arrow]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const dir = btn.dataset.lvArrow === 'next' ? 1 : -1;
        show(index + dir);
      });
    });

    thumbs.forEach((t, n) => {
      t.addEventListener('click', () => show(n));
    });

    if (frame && !reduceMotion) {
      const activeImage = () => {
        const item = images[index];
        return item && item.dataset.lvMediaType === 'image' ? item.querySelector('img') : null;
      };
      frame.addEventListener('mousemove', (e) => {
        const rect = frame.getBoundingClientRect();
        const x = (((e.clientX - rect.left) / rect.width) * 100).toFixed(1);
        const y = (((e.clientY - rect.top) / rect.height) * 100).toFixed(1);
        const img = activeImage();
        if (img) {
          img.style.transformOrigin = `${x}% ${y}%`;
          img.style.transform = 'scale(1.8)';
        }
      });
      frame.addEventListener('mouseleave', () => {
        const img = activeImage();
        if (img) {
          img.style.transformOrigin = '50% 50%';
          img.style.transform = 'scale(1)';
        }
      });
    }

    show(0);

    root.addEventListener('lv:variant-image', (e) => {
      const src = e.detail && e.detail.src;
      if (!src) return;
      const match = images.findIndex((item) => item.dataset.lvMediaId === String(e.detail.mediaId));
      show(match >= 0 ? match : 0);
    });
  })();

  /* ---------------- Mobile gallery ---------------- */
  (function mobileGallery() {
    const track = root.querySelector('[data-lv-track]');
    if (!track) return;
    const slides = Array.from(track.querySelectorAll('[data-lv-slide]'));
    const dots = Array.from(root.querySelectorAll('[data-lv-dot]'));
    let locked = false;
    let lockTimer = 0;

    // Videos have no controls (autoplay/loop/muted only), so playback has
    // to be driven here: play the active slide's video, pause the rest.
    function setActive(i) {
      dots.forEach((d, n) => d.classList.toggle('is-active', n === i));
      slides.forEach((slide, n) => {
        const video = slide.querySelector('video');
        if (!video) return;
        if (n === i) {
          const attempt = video.play();
          if (attempt && attempt.catch) attempt.catch(() => {});
        } else {
          video.pause();
        }
      });
    }

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        locked = true;
        clearTimeout(lockTimer);
        track.scrollTo({ left: i * track.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' });
        setActive(i);
        lockTimer = window.setTimeout(() => {
          locked = false;
        }, 400);
      });
    });

    track.addEventListener(
      'scroll',
      () => {
        if (locked) return;
        const i = Math.round(track.scrollLeft / track.clientWidth);
        setActive(Math.max(0, Math.min(slides.length - 1, i)));
      },
      { passive: true }
    );

    setActive(0);
  })();

  /* ---------------- Color / hardware pickers ---------------- */
  (function optionPickers() {
    const pickers = root.querySelectorAll('[data-lv-option-picker]');
    if (!pickers.length) return;

    const variantIdInput = root.querySelector('[data-lv-variant-id]');
    const priceEl = root.querySelector('[data-lv-price]');
    const ctaButtons = root.querySelectorAll('[data-lv-cta-text]');
    const variantsData = JSON.parse(root.querySelector('[data-lv-variants-json]').textContent);
    const selected = {};

    pickers.forEach((picker) => {
      const name = picker.dataset.lvOptionPicker;
      const activeTile = picker.querySelector('.is-selected');
      selected[name] = activeTile ? activeTile.dataset.lvValue : null;
    });

    function findVariant() {
      return variantsData.find((v) =>
        Object.keys(selected).every((name) => v.options[name] === selected[name])
      );
    }

    function applyVariant(variant) {
      if (!variant) return;
      if (variantIdInput) variantIdInput.value = variant.id;
      if (priceEl) priceEl.textContent = variant.priceFormatted;
      ctaButtons.forEach((btn) => {
        const soldOut = !variant.available;
        btn.disabled = soldOut;
        btn.setAttribute('aria-disabled', soldOut ? 'true' : 'false');
      });
      if (variant.featuredMedia) {
        root.dispatchEvent(
          new CustomEvent('lv:variant-image', {
            detail: { mediaId: variant.featuredMedia.id, src: variant.featuredMedia.src },
          })
        );
      }
    }

    pickers.forEach((picker) => {
      const name = picker.dataset.lvOptionPicker;
      picker.querySelectorAll('[data-lv-value]').forEach((tile) => {
        tile.addEventListener('click', () => {
          picker.querySelectorAll('[data-lv-value]').forEach((t) => {
            t.classList.remove('is-selected');
            t.setAttribute('aria-pressed', 'false');
          });
          tile.classList.add('is-selected');
          tile.setAttribute('aria-pressed', 'true');
          selected[name] = tile.dataset.lvValue;

          const labelTarget = picker.querySelector('[data-lv-selected-label]');
          if (labelTarget) labelTarget.textContent = tile.dataset.lvValue;

          applyVariant(findVariant());
        });
      });
    });
  })();

  /* ---------------- Qty pickers ---------------- */
  root.querySelectorAll('[data-lv-qty]').forEach((wrap) => {
    const display = wrap.querySelector('[data-lv-qty-value]');
    const hiddenInput = wrap.parentElement.querySelector('[data-lv-qty-input]');
    wrap.querySelectorAll('[data-lv-qty-step]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const step = parseInt(btn.dataset.lvQtyStep, 10);
        const current = parseInt(display.textContent || '1', 10);
        const next = Math.max(1, current + step);
        display.textContent = next;
        if (hiddenInput) hiddenInput.value = next;
      });
    });
  });

  /* ---------------- Accordions ---------------- */
  root.querySelectorAll('[data-lv-accordion-item]').forEach((item) => {
    const trigger = item.querySelector('[data-lv-accordion-trigger]');
    if (!trigger) return;
    trigger.addEventListener('click', () => {
      const open = item.classList.toggle('is-open');
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      const icon = item.querySelector('[data-lv-accordion-icon]');
      if (icon) icon.textContent = open ? '−' : '+';
    });
  });

  /* ---------------- Sticky mobile bar ---------------- */
  (function stickyBar() {
    // The sticky bar renders as a sibling of [data-lv-pdp], not a
    // descendant (it needs to escape the content column to sit fixed
    // at the viewport edge) — so it has to be found via document, not root.
    const bar = document.querySelector('[data-lv-sticky]');
    const trigger = root.querySelector('[data-lv-buy-block]');
    if (!bar || !trigger || !('IntersectionObserver' in window)) return;

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          bar.classList.toggle('is-visible', !entry.isIntersecting);
        });
      },
      { rootMargin: '-72px 0px 0px 0px' }
    );
    io.observe(trigger);
  })();

  /* ---------------- Notify modal ---------------- */
  (function notifyModal() {
    // Same deal as the sticky bar: the modal and its openers (one in the
    // main buy box, one in the sticky bar) render outside [data-lv-pdp].
    const openers = document.querySelectorAll('[data-lv-modal-open]');
    const modal = document.querySelector('[data-lv-modal]');
    if (!openers.length || !modal) return;

    function open() {
      modal.classList.remove('is-success');
      modal.classList.add('is-open');
      const form = modal.querySelector('form');
      if (form) form.reset();
      document.addEventListener('keydown', onKeydown);
    }
    function close() {
      modal.classList.remove('is-open');
      document.removeEventListener('keydown', onKeydown);
    }
    function onKeydown(e) {
      if (e.key === 'Escape') close();
    }

    openers.forEach((btn) => btn.addEventListener('click', open));
    modal.querySelectorAll('[data-lv-modal-close]').forEach((btn) => btn.addEventListener('click', close));

    const form = modal.querySelector('form');
    if (form) {
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        const formData = new FormData(form);
        fetch(form.action, { method: 'POST', body: formData, headers: { Accept: 'application/json' } })
          .then(() => {
            modal.classList.add('is-success');
          })
          .catch(() => {
            modal.classList.add('is-success');
          });
      });
    }
  })();
})();
